"use client";

import { css } from "@/../styled-system/css";

const footerBrandContainerClass = css({
  width: "100%",
  sm: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "5",
  },
});

const footerBrandClass = css({
  fontSize: "4xl",
  fontWeight: "bold",
  color: "white",
  lineHeight: "none",
  fontFamily: "ibm",
});

function FooterCopyright() {
  return (
    <div className={footerBrandContainerClass}>
      <div
        className={css({
          mb: "5",
          mx: "auto",
          width: "fit",
          sm: { mb: "0", mx: "0" },
        })}
      >
        <span className={footerBrandClass}>SOLECIT</span>
      </div>
      <div
        className={css({
          mx: "auto",
          width: "fit",
          textAlign: "center",
          lineHeight: "none",
          sm: { mx: "0" },
        })}
      >
        <span
          className={css({
            fontSize: "md",
            color: "gray.300",
          })}
        >
          © 2023 SOLECIT. All Rights Reserved.
        </span>
      </div>
    </div>
  );
}

export default FooterCopyright;
